/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BedType } from './BedType';
import {
    BedTypeFromJSON,
    BedTypeFromJSONTyped,
    BedTypeToJSON,
    BedTypeToJSONTyped,
} from './BedType';

/**
 * 
 * @export
 * @interface BulkUpdateBedTypesRequest
 */
export interface BulkUpdateBedTypesRequest {
    /**
     * 
     */
    bed_types: Array<BedType>;
}

/**
 * Check if a given object implements the BulkUpdateBedTypesRequest interface.
 */
export function instanceOfBulkUpdateBedTypesRequest(value: object): value is BulkUpdateBedTypesRequest {
    if (!('bed_types' in value) || value['bed_types'] === undefined) return false;
    return true;
}

export function BulkUpdateBedTypesRequestFromJSON(json: any): BulkUpdateBedTypesRequest {
    return BulkUpdateBedTypesRequestFromJSONTyped(json, false);
}

export function BulkUpdateBedTypesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateBedTypesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'bed_types': ((json['bed_types'] as Array<any>).map(BedTypeFromJSON)),
    };
}

export function BulkUpdateBedTypesRequestToJSON(json: any): BulkUpdateBedTypesRequest {
    return BulkUpdateBedTypesRequestToJSONTyped(json, false);
}

export function BulkUpdateBedTypesRequestToJSONTyped(value?: BulkUpdateBedTypesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'bed_types': ((value['bed_types'] as Array<any>).map(BedTypeToJSON)),
    };
}

